"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterCourses = void 0;
function filterCourses(courses, filters, excludedField) {
    function matches(field, values) {
        var selection = filters[field];
        var selected = Array.isArray(selection) ? selection : [selection];
        var active = selected.filter(function (value) { return value !== undefined && value !== ""; });
        return field === excludedField || !active.length ||
            active.some(function (value) { return values.some(function (candidate) { return candidate != null && String(candidate) === String(value); }); });
    }
    return courses.filter(function (course) {
        var _a;
        return matches("dag", [course.day]) &&
            matches("locatie", __spreadArray([course.city_id], ((_a = course.locations) !== null && _a !== void 0 ? _a : []).map(function (item) { var _a; return (_a = item.location) === null || _a === void 0 ? void 0 : _a.city_id; }), true)) &&
            matches("seizoen", [course.season_id]) &&
            matches("vakgebied", [course.field_id]) &&
            matches("cursus", [course.id]) &&
            (!filters.is_online || !!course.is_online);
    });
}
exports.filterCourses = filterCourses;
